import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placa',
  templateUrl: './placa.component.html',
  styleUrls: ['./placa.component.sass']
})
export class PlacaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
